import { FishSimple } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { PopularSearches } from "@/components/PopularSearches";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-24 border-t border-border bg-[#1C211E] text-white/90">
      <div className="mx-auto max-w-7xl px-6 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <FishSimple size={28} weight="duotone" className="text-[#F59E0B]" />
            <div className="font-display text-2xl">Reel Funny Goods</div>
          </div>
          <div className="text-[10px] uppercase tracking-[0.25em] text-white/50 mt-1">Est. by the Jimenez family</div>
          <p className="mt-4 max-w-md text-sm text-white/60 leading-relaxed">
            Shamelessly funny shirts, mugs & gear for anglers who take fishing seriously
            and themselves not at all. Printed on demand, shipped worldwide.
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-white/50 mb-4">Shop</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop" className="hover:text-[#F59E0B]">All Products</Link></li>
            <li><Link to="/gifts/for-her" data-testid="footer-gifts-her" className="hover:text-[#F59E0B]">Fishing Gifts for Her</Link></li>
            <li><Link to="/gifts/for-him" data-testid="footer-gifts-him" className="hover:text-[#F59E0B]">Fishing Gifts for Him</Link></li>
            <li><Link to="/quiz" className="hover:text-[#F59E0B]">Humor Quiz</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-white/50 mb-4">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-[#F59E0B]">About Us</Link></li>
            <li><Link to="/login" className="hover:text-[#F59E0B]">Admin Login</Link></li>
            <li><Link to="/track" data-testid="footer-track-order" className="hover:text-[#F59E0B]">Track my order</Link></li>
            <li><Link to="/faq" data-testid="footer-faq" className="hover:text-[#F59E0B]">FAQ</Link></li>
            <li><a href="mailto:orders@reelfunnygoods.com" className="hover:text-[#F59E0B]">Support</a></li>
          </ul>
        </div>
      </div>
      <PopularSearches />
      <div className="border-t border-white/10 py-5 text-center text-xs text-white/40">
        © {new Date().getFullYear()} Reel Funny Goods · Est. by the Jimenez family — All catches reserved.
      </div>
    </footer>
  );
}
